var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisitGetHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F0F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.99 10C14.47 10 10 14.48 10 20C10 25.52 14.47 30 19.99 30C25.52 30 30 25.52 30 20C30 14.48 25.52 10 19.99 10ZM26.92 16H23.97C23.65 14.75 23.19 13.55 22.59 12.44C24.43 13.07 25.96 14.35 26.92 16ZM20 12.04C20.83 13.24 21.48 14.57 21.91 16H18.09C18.52 14.57 19.17 13.24 20 12.04ZM12.26 22C12.1 21.36 12 20.69 12 20C12 19.31 12.1 18.64 12.26 18H15.64C15.56 18.66 15.5 19.32 15.5 20C15.5 20.68 15.56 21.34 15.64 22H12.26ZM13.08 24H16.03C16.35 25.25 16.81 26.45 17.41 27.56C15.57 26.93 14.04 25.66 13.08 24ZM16.03 16H13.08C14.04 14.34 15.57 13.07 17.41 12.44C16.81 13.55 16.35 14.75 16.03 16ZM20 27.96C19.17 26.76 18.52 25.43 18.09 24H21.91C21.48 25.43 20.83 26.76 20 27.96ZM22.34 22H17.66C17.57 21.34 17.5 20.68 17.5 20C17.5 19.32 17.57 18.65 17.66 18H22.34C22.43 18.65 22.5 19.32 22.5 20C22.5 20.68 22.43 21.34 22.34 22ZM22.59 27.56C23.19 26.45 23.65 25.25 23.97 24H26.92C25.96 25.65 24.43 26.93 22.59 27.56ZM24.36 22C24.44 21.34 24.5 20.68 24.5 20C24.5 19.32 24.44 18.66 24.36 18H27.74C27.9 18.64 28 19.31 28 20C28 20.69 27.9 21.36 27.74 22H24.36Z",
    fill: "#32363E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitGetHelp);
export default __webpack_public_path__ + "static/media/VisitGetHelp.a427afa6505c790129af96c7003ac0c7.svg";
export { ForwardRef as ReactComponent };